// Formato de precios
export const formatPrice = (price) => {
  if (!price || isNaN(price)) return '$0.00'
    
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price)
}

// Formato de colores - convierte array a string
export const formatColors = (colors) => {
  if (!colors || !Array.isArray(colors) || colors.length === 0) {
    return 'Sin color especificado'
  }
    
  // Si es un solo color
  if (colors.length === 1) {
    return colors[0]
  }
    
  // Si son múltiples colores
  if (colors.length === 2) {
    return colors.join(' y ')
  }
    
  // Si son más de 2 colores
  const lastColor = colors[colors.length - 1]
  const otherColors = colors.slice(0, -1)
  return `${otherColors.join(', ')} y ${lastColor}`
}

// Formato de fecha
export const formatDate = (date) => {
  if (!date) return ''
    
  const dateObj = new Date(date)
  if (isNaN(dateObj.getTime())) return ''
    
  return new Intl.DateTimeFormat('es-MX', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(dateObj)
}

// Formato de texto corto para descripciones
export const formatShortText = (text, maxLength = 100) => {
  if (!text) return ''
    
  if (text.length <= maxLength) return text
    
  return text.substring(0, maxLength) + '...'
}

// Formato de slug para URLs
export const formatSlug = (text) => {
  if (!text) return ''
    
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remover acentos
    .replace(/[^\w\s-]/g, '') // Remover caracteres especiales
    .replace(/\s+/g, '-') // Espacios a guiones
    .replace(/-+/g, '-') // Múltiples guiones a uno
    .trim('-')
}

// Formato de número de teléfono
export const formatPhoneNumber = (phone) => {
  if (!phone) return ''
    
  // Remover todos los caracteres no numéricos
  const cleaned = phone.replace(/\D/g, '')
    
  // Formato para números de 10 dígitos (México)
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
    
  // Formato para números de 11 dígitos (con código de país)
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return cleaned.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4')
  }
    
  return phone // Devolver original si no coincide con formatos conocidos
}